"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var storybook_1 = require("@eyecons/storybook");
var ra_fetch_1 = require("ra-fetch");
function FormTeams(_a) {
    var _b;
    var channel = _a.channel, type = _a.type, user = _a.user;
    var _c = react_1.useState(false), confirm = _c[0], setConfirm = _c[1];
    var _d = storybook_1.Hooks.useModal(), Modal = _d[0], setModal = _d[1], modalClose = _d[2];
    var _e = ra_fetch_1.useApi('backend').index('teams', (_b = {},
        _b[type.name === 'player' ? 'player_id' : 'club_id'] = channel.id,
        _b.sort = 'name asc',
        _b)), teams = _e[0], setTeams = _e[1];
    if (confirm) {
        setTimeout(function () {
            setConfirm(false);
        }, 2000);
    }
    return react_1.default.createElement(storybook_1.Forms.Field, null,
        react_1.default.createElement(Modal, null),
        user.is_admin && react_1.default.createElement("div", { className: 'storybook-channels-teams-add-wrapper' },
            react_1.default.createElement(storybook_1.Buttons.Button, { type: 'primary', className: 'storybook-channels-teams-add', onClick: function () { return setModal({
                    content: function () { return react_1.default.createElement(storybook_1.Teams.Save, { channel: channel, teams: teams.data, setTeams: setTeams, onSubmit: function () {
                            modalClose();
                            setConfirm(true);
                        } }); },
                }); } }, "Nieuw team")),
        react_1.default.createElement("div", { className: 'storybook-channels-edit-team-list' },
            confirm && react_1.default.createElement(storybook_1.Forms.Confirmation, null, "Team is toegevoegd"),
            react_1.default.createElement(storybook_1.Teams.List, { teams: teams, onDelete: function (team) { return setModal({
                    content: function () { return react_1.default.createElement(storybook_1.Forms.DeleteModal, { title: team.name, route: 'teams', api: 'backend', params: { id: team.id, channel_id: channel.id } }); },
                }); }, onEdit: function (team) { return setModal({
                    content: function () { return react_1.default.createElement(storybook_1.Teams.Save, { team: team, channel: channel, teams: teams.data, setTeams: setTeams, onSubmit: function () {
                            modalClose();
                            setConfirm(true);
                        } }); },
                }); } })));
}
exports.default = FormTeams;
